/**
 * Build a lookup from GET /company-role-permissions/role/:id rows (with joined `page`).
 * @param {unknown[]} apiRows
 * @returns {Record<string, { view: boolean, create: boolean, edit: boolean, delete: boolean }>}
 */
export function permissionRowsToByCode(apiRows) {
  if (!Array.isArray(apiRows)) return {};
  const byCode = {};
  for (const item of apiRows) {
    const code = item?.page?.code;
    if (!code || typeof code !== "string") continue;
    byCode[code] = {
      view: !!item.can_view,
      create: !!item.can_create,
      edit: !!item.can_edit,
      delete: !!item.can_delete,
    };
  }
  return byCode;
}
